import React from "react";
import { connect } from "react-redux";
import { reduxForm } from "redux-form";
import _ from "lodash";
import { Link } from "react-router";
import Title from "../../components/Layout/Title";
import { toastr } from "react-redux-toastr";

import MaskDate from "../../components/Util/MaskDate";
import Dropzone from "react-dropzone";

import { LOTE_LIST_LOAD, LOTE_LIST_UNLOAD } from "../../actions/Constants";

import api from "../../api/apiUtil";
import ReactTable from "react-table";
import fileDownload from "js-file-download";
import jsPDF from "jspdf";
import XLSX from "xlsx/dist/xlsx.mini.min";
import * as FileSaver from "file-saver";
class Lote extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      detalhar: [],
    };
  }

  componentDidMount() {
    if (this.props.currentUser.cnpj == "00000000000191") {
      this.props.onListLoad(api.Contracts.getLoteBB());
    } else if (this.props.currentUser.cnpj == "59285411000113") {
      this.props.onListLoad(api.Contracts.getLotePAN());
    } else if (this.props.currentUser.cnpj === "92228410000102" || this.props.currentUser.cnpj === "60850229000147") {
      this.props.onListLoad(api.Contracts.getLoteOMNI());
    } else {
      this.props.onListLoad(api.Contracts.getLoteFinanceira(this.props.currentUser.idFinanceira));
    }
  }

  componentWillUnmount() {
    this.props.onUnload();
  }

  handleClickUpload = (filesToUpload) => {
    var props = this.props;
    if (this.props.currentUser.cnpj == "00000000000191") {
      Promise.resolve(api.Contracts.sendLoteBB(filesToUpload[0]))
        .then((response) => {
          this.props.onListLoad(api.Contracts.getLoteBB());
          toastr.success("Sucesso", "Arquivo enviado.");
        })
        .catch(function (resp) {
          if (resp.message === "Unauthorized" || resp.message === "jwt expired") {
            api.Auth.logout();
            props.onLogout();
          } else {
            toastr.warning("Atenção", resp.response.body);
          }
        });
    } else if (this.props.currentUser.cnpj == "45512447000188" || this.props.currentUser.cnpj == "42823856000107" || this.props.currentUser.cnpj == "59285411000113") {
      if (filesToUpload[0].type == "text/plain") {
        Promise.resolve(api.Contracts.sendLotePAN(filesToUpload[0]))
          .then((response) => {
            //this.props.onListLoad(api.Contracts.getLotePAN());
            this.props.onListLoad(api.Contracts.getLoteFinanceira(this.props.currentUser.idFinanceira));
            toastr.success("Sucesso", "Arquivo enviado.");
          })
          .catch(function (resp) {
            if (resp.message === "Unauthorized" || resp.message === "jwt expired") {
              api.Auth.logout();
              props.onLogout();
            } else {
              toastr.warning("Atenção", resp.response.body);
            }
          });
      } else {
        Promise.resolve(api.Contracts.sendLoteCSV(filesToUpload[0]))
          .then((response) => {
            this.props.onListLoad(api.Contracts.getLoteFinanceira(this.props.currentUser.idFinanceira));
            toastr.success("Sucesso", "Arquivo enviado.");
          })
          .catch(function (resp) {
            if (resp.message === "Unauthorized" || resp.message === "jwt expired") {
              api.Auth.logout();
              props.onLogout();
            } else {
              toastr.warning("Atenção", resp.response.body);
            }
          });

        // Promise.resolve(api.Contracts.sendLotePANXLS(filesToUpload[0]))
        //   .then((response) => {
        //     this.props.onListLoad(api.Contracts.getLotePAN());
        //     toastr.success("Sucesso", "Arquivo enviado.");
        //   })
        //   .catch(function (resp) {
        //     if (resp.message === "Unauthorized" || resp.message === "jwt expired") {
        //       api.Auth.logout();
        //       props.onLogout();
        //     } else {
        //       toastr.warning("Atenção", resp.response.body);
        //     }
        //   });
      }
    } else if (this.props.currentUser.cnpj === "92228410000102" || this.props.currentUser.cnpj === "60850229000147") {
      Promise.resolve(api.Contracts.sendLoteOMNIXLS(filesToUpload[0]))
        .then((response) => {
          this.props.onListLoad(api.Contracts.getLoteOMNI());
          toastr.success("Sucesso", "Arquivo enviado.");
        })
        .catch(function (resp) {
          if (resp.message === "Unauthorized" || resp.message === "jwt expired") {
            api.Auth.logout();
            props.onLogout();
          } else {
            toastr.warning("Atenção", resp.response.body);
          }
        });
    } else {
      if (filesToUpload[0].type == "text/plain") {
        Promise.resolve(api.Contracts.sendLoteBV(filesToUpload[0]))
          .then((response) => {
            this.props.onListLoad(api.Contracts.getLoteFinanceira(this.props.currentUser.idFinanceira));
            toastr.success("Sucesso", "Arquivo enviado.");
          })
          .catch(function (resp) {
            if (resp.message === "Unauthorized" || resp.message === "jwt expired") {
              api.Auth.logout();
              props.onLogout();
            } else {
              toastr.warning("Atenção", resp.response.body);
            }
          });
      } else {
        Promise.resolve(api.Contracts.sendLoteCSV(filesToUpload[0]))
          .then((response) => {
            this.props.onListLoad(api.Contracts.getLoteFinanceira(this.props.currentUser.idFinanceira));
            toastr.success("Sucesso", "Arquivo enviado.");
          })
          .catch(function (resp) {
            if (resp.message === "Unauthorized" || resp.message === "jwt expired") {
              api.Auth.logout();
              props.onLogout();
            } else {
              toastr.warning("Atenção", resp.response.body);
            }
          });
      }
    }
  };

  handleClickDownload = (value) => {
    var props = this.props;
    Promise.resolve(this.props.currentUser.cnpj == "59285411000113" ? api.Contracts.recuperaRespostasPAN(value.id) : api.Contracts.getLote(value.id))
      .then((response) => {
        fileDownload(response, this.props.currentUser.cnpj == "59285411000113" ? value.nome.substring(0, 3) + "RET_" + value.nome.substring(3) : value.nome);
      })
      .catch(function (resp) {
        if (resp.message === "Unauthorized" || resp.message === "jwt expired") {
          api.Auth.logout();
          props.onLogout();
        } else {
          toastr.error("Erro", "Ocorreu um erro ao realizar a operação!");
        }
      });
  };

  async exportToPDF(values) {
    await this.recuperaDadosContrato(values.id);
    const unit = "pt";
    const size = "A4"; // Use A1, A2, A3 or A4
    const orientation = "landscape"; // portrait or landscape
    const marginLeft = 30;
    const doc = new jsPDF(orientation, unit, size);
    var width = doc.internal.pageSize.getWidth();
    var height = doc.internal.pageSize.getHeight();

    doc.page = 1;
    doc.setFontSize(12);

    var startY = 95;

    var footer = function () {
      doc.setFontSize(7);
      doc.text(width - 50, height - 30, "Página " + doc.page);
      doc.page++;
    };

    var title = `Relatório Remessa`;
    title = title + `\n\nNome do Arquivo: ${values.nome}`;
    title = title + `\nData Inclusão: ${MaskDate.TO_BR(values.data)}`;
    title = title + `\nValidações: OK`;
    var fileName = `RelatorioRemessa - ${values.nome}`;
    var content = {};
    var body = [];
    var head = [[{ content: "UF" }, { content: "Número do Contrato" }, { content: "Situação" }, { content: "Chassi" }, { content: "Gravame" }]];
    var styles = {
      cellPadding: 1.5,
      overflow: "linebreak",
      valign: "middle",
      halign: "center",
      lineColor: [0, 0, 0],
      lineWidth: 0.2,
      fontSize: 10,
    };

    body = this.state.detalhar
      .filter((detalhe) => detalhe.idLoteApi == values.id)
      .map((row) => [
        row.uf,
        row.numero,
        row.status == 0 || row.status == 8
          ? "Contrato Criado"
          : row.status == 2
          ? "Contrato Registrado"
          : row.status == 3
          ? "Imagem do Contrato Enviada"
          : row.status == 5
          ? "Contrato Baixado"
          : row.status == 6
          ? "Contrato Cancelado"
          : row.status == 7
          ? "Contrato Averbado"
          : row.status == 11
          ? "Contrato Em Processamento"
          : row.status == 90
          ? "Erro no registro do Contrato"
          : row.status == 91
          ? "Contrato Excluído"
          : row.status,
        row.chassi,
        row.numGravame,
      ]);

    styles.fontSize = 8;

    content = {
      startY,
      head,
      body,
      bodyStyles: { valign: "top" },
      styles,
      didDrawPage: function (data) {
        footer();
      },
    };

    doc.text(title, marginLeft, 30);
    doc.autoTable(content);
    doc.save(`${fileName}.pdf`);
  }

  async exportToXLSCSV(values, type) {
    await this.recuperaDadosContrato(values.id);
    var DataExcel = [];
    const headersExcell = [["UF", "Número do Contrato", "Situação", "Chassi", "Gravame"]];

    DataExcel = this.state.detalhar
      .filter((detalhe) => detalhe.idLoteApi == values.id)
      .map((row) => {
        return {
          uf: row.uf,
          numero: row.numero,
          situacao:
            row.status == 0 || row.status == 8
              ? "Contrato Criado"
              : row.status == 2
              ? "Contrato Registrado"
              : row.status == 3
              ? "Imagem do Contrato Enviada"
              : row.status == 5
              ? "Contrato Baixado"
              : row.status == 6
              ? "Contrato Cancelado"
              : row.status == 7
              ? "Contrato Averbado"
              : row.status == 11
              ? "Contrato Em Processamento"
              : row.status == 90
              ? "Erro no registro do Contrato"
              : row.status == 91
              ? "Contrato Excluído"
              : row.status,
          chassi: row.chassi,
          gravame: row.numGravame,
        };
      });

    var ws = XLSX.utils.aoa_to_sheet(headersExcell);
    XLSX.utils.sheet_add_json(ws, DataExcel, {
      skipHeader: true,
      origin: "A2",
    });

    var wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "RelatorioRemessa");
    var wbout = XLSX.write(wb, { bookType: type, type: "array" });
    FileSaver.saveAs(new Blob([wbout], { type: "application/octet-stream" }), `RelatorioRemessa.${type}`);
  }

  async recuperaDadosContrato(value) {
    if (this.state.detalhar.findIndex((val) => val.idLoteApi == value) == -1) {
      await Promise.resolve(api.Contracts.getContractsByIdLote(value)).then((res) => {
        _.forEach(res, function (r) {
          r.hash = value;
        });
        this.setState({ detalhar: [...this.state.detalhar, ...res] });
      });
    }
  }

  filteredDetails(id) {
    return this.state.detalhar
      .filter((detalhe) => detalhe.idLoteApi == id)
      .map((det, index) => {
        return (
          <tr key={index}>
            <td className="text-center align-middle">{det.uf}</td>
            <td className="text-center align-middle">{det.numero}</td>
            <td className="text-center align-middle">
              {det.status == 0 || det.status == 8
                ? "Contrato Criado"
                : det.status == 2
                ? "Contrato Registrado"
                : det.status == 3
                ? "Imagem do Contrato Enviada"
                : det.status == 5
                ? "Contrato Baixado"
                : det.status == 6
                ? "Contrato Cancelado"
                : det.status == 7
                ? "Contrato Averbado"
                : det.status == 11
                ? "Contrato Em Processamento"
                : det.status == 90
                ? "Erro no registro do Contrato"
                : det.status == 91
                ? "Contrato Excluído"
                : det.status}
            </td>
            <td className="text-center align-middle">{det.chassi}</td>
            <td className="text-center align-middle">{det.numGravame}</td>
          </tr>
        );
      });
  }

  render() {
    return (
      <div>
        <Title routes={this.props.routes} params={this.props.params} description="Upload/Download Lote Arquivos" />
        <div className="content">
          <div className="row">
            <div className="col-lg-12">
              <div className="hpanel">
                <div className="panel-heading">
                  <div className="panel-tools">
                    {(this.props.currentUser.cnpj == "59285411000114" || this.props.currentUser.cnpj == "42823856000107" || this.props.currentUser.cnpj == "59285411000113") && (
                      <Dropzone accept=".csv" name="file" className="dropzone-blank fallback float-right" multiple={false} onDrop={(filesToUpload, e) => this.handleClickUpload(filesToUpload)}>
                        <button type="button" className="btn btn-primary btn-xs">
                          <i className="fa fa-upload" /> Enviar Novo Arquivo (.csv)
                        </button>
                      </Dropzone>
                    )}
                    {this.props.currentUser.cnpj === "92228410000102" && (
                      <Dropzone accept=".xlsx" name="file" className="dropzone-blank fallback float-right" multiple={false} onDrop={(filesToUpload, e) => this.handleClickUpload(filesToUpload)}>
                        <button type="button" className="btn btn-primary btn-xs">
                          <i className="fa fa-upload" /> Enviar Novo Arquivo (.xls)
                        </button>
                      </Dropzone>
                    )}
                    {this.props.currentUser.cnpj !== "92228410000102" && this.props.currentUser.cnpj !== "60850229000147" && this.props.currentUser.cnpj !== "06044551000133" && (
                      <Dropzone accept=".txt" name="file" className="dropzone-blank fallback float-right" multiple={false} onDrop={(filesToUpload, e) => this.handleClickUpload(filesToUpload)}>
                        <button type="button" className="btn btn-primary btn-xs">
                          <i className="fa fa-upload" /> Enviar Novo Arquivo (.txt)
                        </button>
                      </Dropzone>
                    )}
                  </div>
                  Arquivos enviados
                </div>
                <div className="panel-body">
                  <div className="table-responsive">
                    {this.props.all && this.props.all.length > 0 ? (
                      <ReactTable
                        className="-striped -highlight"
                        defaultPageSize={50}
                        data={this.props.all}
                        loadingText="Carregando..."
                        noDataText="Nenhuma Informação encontrada"
                        rowsText="linhas"
                        showPageSizeOptions={false}
                        minRows={1}
                        showPagination={true}
                        previousText="Anterior"
                        nextText="Próximo"
                        pageText="página"
                        ofText="de"
                        getTdProps={(state, rowInfo, column, instance) => {
                          return {
                            onClick: async (e, handleOriginal) => {
                              if (column.Header == "Detalhar") {
                                await this.recuperaDadosContrato(rowInfo.original.id);
                              }

                              if (handleOriginal) {
                                handleOriginal();
                              }
                              // IMPORTANT! React-Table uses onClick internally to trigger
                              // events like expanding SubComponents and pivots.
                              // By default a custom 'onClick' handler will override this functionality.
                              // If you want to fire the original onClick handler, call the
                              // 'handleOriginal' function.
                            },
                          };
                        }}
                        SubComponent={(row) => {
                          return (
                            <div className="panel-body">
                              <div className="table-responsive">
                                <table cellPadding="1" cellSpacing="1" className="table table-bordered table-striped">
                                  <thead>
                                    <tr>
                                      <th className="text-center align-middle">UF</th>
                                      <th className="text-center align-middle">Número do Contrato</th>
                                      <th className="text-center align-middle">Situação</th>
                                      <th className="text-center align-middle">Chassi</th>
                                      <th className="text-center align-middle">Gravame</th>
                                    </tr>
                                  </thead>
                                  <tbody>{this.filteredDetails(row.original.id)}</tbody>
                                </table>
                              </div>
                            </div>
                          );
                        }}
                        columns={[
                          {
                            expander: true,
                            Header: "Detalhar",
                            width: 65,
                            headerClassName: "font-extra-bold",
                            Expander: ({ isExpanded, ...rest }) => <div>{isExpanded ? <span>&#x2bc6;</span> : <span>&#x2bc8;</span>}</div>,
                            style: {
                              cursor: "pointer",
                              fontSize: 15,
                              padding: "0",
                              textAlign: "center",
                              userSelect: "none",
                            },
                          },
                          {
                            Header: "Data Inclusão",
                            accessor: "rowData",
                            className: "align-middle text-center",
                            headerClassName: "font-extra-bold",
                            width: 120,
                            Cell: (rowData) => {
                              return (
                                <div>
                                  <span>{MaskDate.TO_BR(rowData.original.data)}</span>
                                  <br />
                                </div>
                              );
                            },
                          },
                          {
                            Header: "Nome do Arquivo",
                            accessor: "nome",
                            headerClassName: "font-extra-bold",
                            Cell: (rowDataNome) => {
                              return (
                                <div>
                                  {rowDataNome.original.nome && !rowDataNome.original.nome2 ? (
                                    <span>{rowDataNome.original.nome}</span>
                                  ) : (
                                    <>
                                      <span>Arquivo Envio: {rowDataNome.original.nome}</span>
                                      <br />
                                      <span>Arquivo Retorno: {rowDataNome.original.nome2}</span>
                                    </>
                                  )}
                                </div>
                              );
                            },
                          },
                          {
                            Header: "Ação",
                            className: "align-middle text-center",
                            headerClassName: "font-extra-bold",
                            width: 450,
                            Cell: (row) => {
                              return (
                                <div>
                                  <div className="btn-group">
                                    <Link className="btn btn-default btn-sm" onClick={() => this.handleClickDownload(row.original)}>
                                      {" "}
                                      Download{" "}
                                    </Link>
                                    <Link className="btn btn-default btn-sm" onClick={() => this.exportToPDF(row.original)}>
                                      {" "}
                                      Relatório PDF{" "}
                                    </Link>
                                    <Link className="btn btn-default btn-sm" onClick={() => this.exportToXLSCSV(row.original, "csv")}>
                                      {" "}
                                      Relatório CSV{" "}
                                    </Link>
                                    <Link className="btn btn-default btn-sm" onClick={() => this.exportToXLSCSV(row.original, "xlsx")}>
                                      {" "}
                                      Relatório XLSX{" "}
                                    </Link>
                                  </div>
                                </div>
                              );
                            },
                          },
                        ]}
                      />
                    ) : (
                      <small>Nenhum registro encontrado</small>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  onListLoad: (payload) => dispatch({ type: LOTE_LIST_LOAD, payload }),
  onUnload: (payload) => dispatch({ type: LOTE_LIST_UNLOAD, payload }),
});

const mapStateToProps = (state) => ({
  ...state.lote,
  currentUser: state.common.currentUser,
});

const form = reduxForm({
  form: "LoteForm",
});

export default connect(mapStateToProps, mapDispatchToProps)(form(Lote));
